import type { MutableRefObject } from 'react';
import type { UseFormReturn } from 'react-hook-form';

/** Used with lifecycle `submitBehavior: 'clearForm'` only (not modal `reset`). */
/** Clear submit/touch/error state after async handleSubmit completes (RHF re-sets isSubmitted). */
const POST_SUBMIT_FORM_RESET_OPTIONS = {
  keepErrors: false,
  keepDirty: false,
  keepIsSubmitted: false,
  keepTouched: false,
  keepIsValid: false,
  keepSubmitCount: false,
} as const;

export function schedulePostSubmitFormReset(
  form: UseFormReturn<Record<string, unknown>>,
  emptyValues: Record<string, unknown>,
  refs: {
    hydratingRef: MutableRefObject<boolean>;
    hydrationEpochRef: MutableRefObject<number>;
    triggerTimerRef: MutableRefObject<number | null>;
  },
): void {
  if (refs.triggerTimerRef.current != null) {
    clearTimeout(refs.triggerTimerRef.current);
    refs.triggerTimerRef.current = null;
  }
  requestAnimationFrame(() => {
    refs.hydratingRef.current = true;
    form.reset(emptyValues, POST_SUBMIT_FORM_RESET_OPTIONS);
    requestAnimationFrame(() => {
      refs.hydratingRef.current = false;
      refs.hydrationEpochRef.current += 1;
    });
  });
}
